import { iotsUtils } from '@bedc/core';

export const EqualsType = iotsUtils.fromList(['eq', 'ne', 'includes'] as const);
